import React, { Children } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Laptop, Code, Lightbulb, HandHeart, GraduationCap, Heart } from 'lucide-react';
export function AnseCanotPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-111">
      <Header data-id="element-112" />

      <main data-id="element-113">
        {/* Hero Section */}
        <section className="relative pt-32 pb-20 overflow-hidden" data-id="element-114">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-115">
            <a href="/saint-lucia" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-116">
              <ArrowLeft className="w-5 h-5 mr-2" data-id="element-117" />
              Back to Saint Lucia
            </a>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-118">
              {/* Text */}
              <div data-id="element-119">
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-500/20 border border-emerald-400/30 text-emerald-300 text-sm font-bold mb-6 uppercase tracking-wider" data-id="element-120">
                  <HandHeart className="w-4 h-4" data-id="element-121" />
                  Community Outreach
                </div>

                <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight" data-id="element-122">
                  Anse Canot
                  <br data-id="element-123" />
                  <span className="text-emerald-400" data-id="element-124">
                    Community Outreach Foundation
                  </span>
                </h1>

                <p className="text-xl text-slate-300 leading-relaxed mb-6" data-id="element-125">
                  Empowering the next generation of Saint Lucia by giving our
                  children the tools, knowledge, and confidence to thrive in a
                  digital world.
                </p>

                <p className="text-lg text-slate-400 leading-relaxed" data-id="element-126">
                  We believe every child deserves the opportunity to learn,
                  create, and lead — no matter where they grow up.
                </p>
              </div>

              {/* Image */}
              <div className="relative" data-id="element-127">
                <div className="absolute -inset-4 bg-emerald-400/20 blur-3xl rounded-full" data-id="element-128" />
                <div className="relative rounded-3xl overflow-hidden border-2 border-emerald-500/30 shadow-2xl" data-id="element-129">
                  <img src="https://cdn.magicpatterns.com/uploads/7uNz2ua1otGtYqp5kJX3Ki/chXa9.jpg" alt="Children of the Anse Canot community" className="w-full h-auto" data-id="element-130" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="py-20" data-id="element-131">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
            <div className="bg-white/5 backdrop-blur rounded-3xl border border-emerald-500/20 p-10 md:p-14 text-center" data-id="element-133">
              <div className="w-16 h-16 rounded-full bg-emerald-400/20 flex items-center justify-center mx-auto mb-6" data-id="element-134">
                <Heart className="w-8 h-8 text-emerald-300" data-id="element-135" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-136">
                Our Mission
              </h2>
              <p className="text-lg md:text-xl text-slate-300 leading-relaxed" data-id="element-137">
                To build up the children of our community by introducing them to
                the world of{' '}
                <span className="text-emerald-300 font-semibold" data-id="element-138">
                  technology
                </span>{' '}
                and{' '}
                <span className="text-emerald-300 font-semibold" data-id="element-139">
                  digital skills
                </span>
                . We're creating pathways where curiosity meets opportunity, so
                that every young mind in Anse Canot can dream bigger and reach
                further.
              </p>
            </div>
          </div>
        </section>

        {/* Focus Areas */}
        <section className="pb-20" data-id="element-140">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
            <div className="text-center mb-12" data-id="element-142">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-143">
                What We Focus On
              </h2>
              <p className="text-lg text-slate-400" data-id="element-144">
                Building tomorrow's innovators, one skill at a time
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-145">
              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-emerald-400/50 transition-colors p-8 text-center" data-id="element-146">
                <div className="w-14 h-14 rounded-full bg-emerald-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-147">
                  <Laptop className="w-7 h-7 text-emerald-300" data-id="element-148" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-149">
                  Tech Literacy
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-150">
                  Introducing kids to computers, the internet, and the digital
                  tools that shape our world.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-emerald-400/50 transition-colors p-8 text-center" data-id="element-151">
                <div className="w-14 h-14 rounded-full bg-emerald-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-152">
                  <Code className="w-7 h-7 text-emerald-300" data-id="element-153" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-154">
                  Digital Skills
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-155">
                  Hands-on lessons in coding, creating, and using technology to
                  solve real problems.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-emerald-400/50 transition-colors p-8 text-center" data-id="element-156">
                <div className="w-14 h-14 rounded-full bg-emerald-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-157">
                  <Lightbulb className="w-7 h-7 text-emerald-300" data-id="element-158" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-159">
                  Creative Thinking
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-160">
                  Encouraging curiosity, problem-solving, and the confidence to
                  bring ideas to life.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-emerald-400/50 transition-colors p-8 text-center" data-id="element-161">
                <div className="w-14 h-14 rounded-full bg-emerald-400/20 flex items-center justify-center mx-auto mb-5" data-id="element-162">
                  <GraduationCap className="w-7 h-7 text-emerald-300" data-id="element-163" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-164">
                  Future Ready
                </h3>
                <p className="text-slate-400 text-sm" data-id="element-165">
                  Preparing youth with the skills they'll need to succeed in
                  school, careers, and life.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="pb-24" data-id="element-166">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
            <div className="bg-gradient-to-br from-emerald-500/20 via-emerald-600/10 to-slate-900/40 backdrop-blur rounded-3xl border border-emerald-400/30 p-12 text-center" data-id="element-168">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-169">
                Join Us in Building Brighter Futures
              </h2>
              <p className="text-lg text-slate-300 mb-2" data-id="element-170">
                Every child in our community deserves a chance to thrive.
              </p>
              <p className="text-slate-400" data-id="element-171">
                More information about how to support and get involved is coming
                soon.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-172" />
    </div>;
}